<template>
    <div class="row justify-content-center">

      <div class="col-12 text-center">

        <form-wizard
        v-if="wizardDisplay"
        ref="wizard"
        :title="settings['appointmentgroup.default.frontend.heading'].value"
        :subtitle="settings['appointmentgroup.default.frontend.subheading'].value"
        back-button-text="Zurück"
        next-button-text="Weiter"
        finish-button-text="Reservieren"
        color="#006eb8"
        @on-change="onTabChange">
          <tab-content v-if="wizardDisplayStep1" :title="settings['appointmentgroup.default.frontend.heading.tab1'].value" class="text-left" :before-change="validateSubsidiaryGroup">

            <div v-if="subsidiaries.length > 1">
              <b>{{settings['appointmentgroup.default.frontend.heading.subsidiaries'].value}}</b>
              <b-form-group class="mt-2">
                <b-form-radio v-for="subsidiary in subsidiaries" :key="subsidiary.id" @input="getGroups" v-model="selectedSubsidiary" name="subsidiary" :value="subsidiary">{{subsidiary.title}}</b-form-radio>
              </b-form-group>
            </div>

            <div v-if="selectedSubsidiary && groups.length > 1">
              <b>{{settings['appointmentgroup.default.frontend.heading.groups'].value}}</b>
              <b-form-group class="mt-2">
                <b-form-radio v-for="group in groups" :key="group.id" v-model="selectedGroup" name="group" :value="group">{{group.title}}</b-form-radio>
              </b-form-group>
            </div>

            <div v-if="preform">
              <div v-for="formelement in preform" :key="formelement.key">

                <b-row v-if="formelement.type === 'select'">
                  <b-col cols="12" md="6">
                    <b-form-group
                        label-cols-sm="12"
                        label-cols-lg="12"
                        :name="formelement.key"
                        :label="formelement.label"
                        :state="formStates[formelement.key]"
                        invalid-feedback="Bitte wählen Sie eine Option"
                    >
                      <b-form-radio-group
                          v-model="userInput[formelement.key]"
                          :options="formelement.config.options"
                          @input="validateFormelement(formelement)"
                          value-field="content"
                          text-field="label"
                          stacked
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <div v-if="userInput[formelement.key]" v-html="nl2br(userInput[formelement.key])"></div>
                  </b-col>
                </b-row>

                </div>
            </div>

          </tab-content>
          <tab-content :title="settings['appointmentgroup.default.frontend.heading.tab2'].value" class="text-left" :before-change="validateDate">
            <div v-if="selectedSubsidiary && selectedGroup">

              <b>{{selectedSubsidiary.title}}</b> / <b>{{selectedGroup.title}}</b>
              <br/>
              {{ settings['appointmentgroup.default.frontend.heading.calendar'].value }}
              <br/>
              <b-alert v-if="errors.NO_APPOINTMENTS_LEFT" variant="warning" class="m-5" show>Entschuldigung, momentan sind keine freien Termine mehr verfügbar!</b-alert>
              <div class="row" v-if="!errors.NO_APPOINTMENTS_LEFT">
                <div class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6 text-center">

                  <flat-pickr
                          v-model="selectedDay"
                          :config="calendarConfig"
                          class="mt-2"
                          @input="onDayClick">
                  </flat-pickr>

                </div>
                <div class="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-6 p-3 pt-0 text-center">
                  <div v-if="selectedDay"><b>{{selectedDay | moment('dddd, DD. MMMM YYYY')}}</b>
                    <br/>
                    {{ settings['appointmentgroup.default.frontend.heading.appointment'].value }}

                    <b-form-group class="mt-2 font-monospace">
                      <b-form-radio-group v-model="selectedDate" name="appointment">
                        <b-form-radio v-for="appointment in availableSlots" :key="appointment.id" :value="appointment">{{ appointment.date | moment("HH:mm")}}</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                  </div>
                </div>
              </div>

            </div>

          </tab-content>
          <tab-content :title="settings['appointmentgroup.default.frontend.heading.tab3'].value" class="text-left" :before-change="validateForm">

            <div v-if="selectedSubsidiary && selectedGroup && selectedDate">
              <b>{{selectedSubsidiary.title}}</b> / <b>{{selectedGroup.title}}</b><br/>
              {{selectedDate.date | moment('dddd, DD. MMMM YYYY')}} um {{selectedDate.date | moment('HH:mm')}} Uhr
              <br/>
              <br/>
              {{ settings['appointmentgroup.default.frontend.heading.form'].value }}
              <hr/>

              <div v-for="formelement in form" :key="formelement.key">

                <div :key="formValidateCount">

                  <b-form-group
                          v-if="formelement.type === 'input'"
                          label-cols-sm="6"
                          label-cols-lg="6"
                          :name="formelement.key"
                          :label="formelement.label"
                          :state="formStates[formelement.key]"
                          invalid-feedback="Bitte füllen Sie dieses Feld aus"
                          :validated="formStates[formelement.key]"
                  >
                    <b-form-input @update="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
                  </b-form-group>

                  <b-form-group
                          v-if="formelement.type === 'email'"
                          label-cols-sm="6"
                          label-cols-lg="6"
                          :name="formelement.key"
                          :label="formelement.label"
                          :state="formStates[formelement.key]"
                          invalid-feedback="Bitte geben Sie hier eine gültige E-Mail Adresse ein"
                          :validated="formStates[formelement.key]"
                  >
                    <b-form-input @input="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
                  </b-form-group>

                  <b-form-group
                          v-if="formelement.type === 'textarea'"
                          label-cols-sm="6"
                          label-cols-lg="6"
                          :name="formelement.key"
                          :label="formelement.label"
                          :state="formStates[formelement.key]"
                          invalid-feedback="Bitte füllen Sie dieses Feld aus"
                          :validated="formStates[formelement.key]"
                  >
                    <b-form-textarea @input="validateFormelement(formelement)" v-model="userInput[formelement.key]"></b-form-textarea>
                  </b-form-group>

                  <div class="mt-3 form-html-content" v-if="formelement.type === 'html'" v-html="formelement.config.content">
                  </div>

                  <b-form-group
                          v-if="formelement.type === 'select' && (!formelement.config.has_appointment_filter || formelement.config.has_appointment_filter == 'false')"
                          label-cols-sm="6"
                          label-cols-lg="6"
                          :name="formelement.key"
                          :label="formelement.label"
                          :state="formStates[formelement.key]"
                          invalid-feedback="Bitte wählen Sie eine Option"
                  >
                    <b-form-radio-group
                            v-model="userInput[formelement.key]"
                            :options="formelement.config.options"
                            @input="validateFormelement(formelement)"
                            value-field="content"
                            text-field="label"
                            stacked
                    ></b-form-radio-group>

                    <div class="mt-3" v-if="userInput[formelement.key]" v-html="nl2br(userInput[formelement.key])">
                    </div>
                  </b-form-group>

                  <b-form-checkbox
                          class="mt-3"
                          size="xl"
                          v-model="userInput[formelement.key]"
                          :name="formelement.key"
                          v-if="formelement.type === 'checkbox'"
                          :state="formStates[formelement.key]"
                          unchecked-value=""
                          invalid-feedback="Bitte bestätigen Sie dieses Feld"
                          @input="validateFormelement(formelement)">{{formelement.label}}</b-form-checkbox>

                  <div v-if="formelement.type === 'captcha'">

                    <hr/>

                    Um Ihren Termin am <b>{{selectedDate.date | moment('dddd, DD. MMMM YYYY')}} um {{selectedDate.date | moment('HH:mm')}} Uhr</b> zu bestätigen, geben Sie bitte folgenden Sicherheitscode ein und klicken danach auf &quot;Termin reservieren&quot;.

                    <div class="row mt-3">
                      <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                        <div v-html="formelement.config.content"></div>
                      </div>
                      <div class="col-12 col-md-12 col-sm-12 col-lg-6 col-xl-6">
                        <b-form-input @input="validateFormelement(formelement)" placeholder="Hier bitte den fünfstelligen Sicherheitscode eingeben" invalid-feedback="Bitte füllen Sie dieses Feld aus" :state="formStates[formelement.key]" v-model="userInput[formelement.key]" trim></b-form-input>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

              <b-alert show variant="danger" v-if="errors.ERR_NO_TICKETS_LEFT">
                {{settings['appointmentgroup.default.frontend.message.no_tickets_left'].value}}
              </b-alert>

            </div>

          </tab-content>
          <tab-content :title="settings['appointmentgroup.default.frontend.heading.tab4'].value" class="text-left">

            <h4>{{settings['appointmentgroup.default.frontend.heading.message.success'].value}}</h4>
            <div class="form-html-content" v-html="settings['appointmentgroup.default.frontend.message.success'].value"></div>
            <br/><br/>
            <b-button @click="resetWizard" >Weiteren Termin reservieren</b-button>

          </tab-content>

          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
              <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Zurück</wizard-button>
            </div>
            <div class="wizard-footer-right">
              <div v-if="wizardDisplayStep1">
                <wizard-button v-if="props.activeTabIndex < 2" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Weiter</wizard-button>
                <wizard-button v-if="props.activeTabIndex == 2" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Termin reservieren</wizard-button>
              </div>
              <div v-else>
                <wizard-button v-if="props.activeTabIndex < 1" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Weiter</wizard-button>
                <wizard-button v-if="props.activeTabIndex == 1" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Termin reservieren</wizard-button>
              </div>
            </div>
          </template>

        </form-wizard>

      </div>

    </div>

</template>

<script>

    import Vue from 'vue'
    import { BButton, BFormGroup, BFormInput, BFormCheckbox, BFormRadio, BAlert, BFormRadioGroup, BFormTextarea, BRow, BCol} from 'bootstrap-vue'
    import flatPickr from 'vue-flatpickr-component';
    import {German as GermanLocale} from 'flatpickr/dist/l10n/de.js';
    // import {  validateAll } from 'indicative/validator'
    /* MOMENT */
    const moment = require('moment')
    moment.locale('de')

    Vue.use(require('vue-moment'), {
        moment
    })

    import VueFormWizard from 'vue-form-wizard'
    Vue.use(VueFormWizard)

    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.use(VueAxios, axios)
    axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/v1`

export default {
  name: 'Home',
  components: {
    'b-button': BButton,
    'b-alert': BAlert,
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-form-radio': BFormRadio,
    'b-form-radio-group': BFormRadioGroup,
    'b-form-checkbox': BFormCheckbox,
    'b-form-textarea': BFormTextarea,
    'b-row': BRow,
    'b-col': BCol,
    flatPickr
  },
  data () {
    return {
      calendarConfig: {
        inline: true,
        static: true,
        locale: GermanLocale,
        enable: [],
        minDate: null
      },
      errors: {},
      subsidiaries: [],
      groups: [],
      selectedSubsidiary:null,
      selectedGroup:null,
      selectedDate:null,
      selectedDay:null,
      groupFilterFromPreForm: [],
      userInput: {},
      availableSlots: [],
      preform: [],
      form: [],
      formStates: {},
      formRules: {},
      formValidateCount: 0,
      minDate: '',
      maxDate: '',
      wizardDisplayStep1: true,
      wizardDisplay: false,
      formToken: null,
      settings:null,
      groupSettings:null,
      urlQuery: {
        subsidiary_id: null,
        group_id: null
      }
    }
  },
  async mounted() {

    let uri = window.location.search
    let UrlParams = new URLSearchParams(uri)
    this.urlQuery.subsidiary_id = parseInt(UrlParams.get("subsidiary"));
    this.urlQuery.group_id= parseInt(UrlParams.get("group"));

    const result = await this.axios.get('subsidiaries')
    this.subsidiaries = result.data

    const settings = await this.axios.get('/settings?path=appointmentgroup.default.frontend.*')
    this.settings = settings.data

    if(!isNaN(this.urlQuery.subsidiary_id) && this.urlQuery.subsidiary_id > 0) {
      for(let i = 0; i < this.subsidiaries.length; i++) {
        if(this.subsidiaries[i].id == this.urlQuery.subsidiary_id) {
          this.selectedSubsidiary = this.subsidiaries[i]
        }
      }
    }

    if(this.selectedSubsidiary !== null) {
      await this.getGroups()
    }
    else if(this.subsidiaries.length === 1) {
      this.selectedSubsidiary = this.subsidiaries[0]
      await this.getGroups()
    }
    else {
      this.wizardDisplay = true
    }



  },
  computed: {
  },
  watch: {
    selectedGroup: function() {
      this.onGroupChange()
    }
  },
  methods: {
    async onTabChange(prevIndex, nextIndex) {

      const dateSelectViewIndex = this.wizardDisplayStep1 ? 1 : 0

      if(nextIndex === dateSelectViewIndex) { // Choose Date View

        if(this.errors.ERR_NO_TICKETS_LEFT) {
          // back from further left with no tickets left
          this.selectedDay = null
          this.selectedDate = null
        }

        await this.getAvailableDates()

      }
    },
    async getGroups() {

      this.selectedGroup = null

      const result = await this.axios.get('appointment-groups/?subsidiary=' + this.selectedSubsidiary.id)
      this.groups = result.data

      if(!isNaN(this.urlQuery.group_id) && this.urlQuery.group_id > 0) {
        for(let i = 0; i < this.groups.length; i++) {
          if(this.groups[i].id == this.urlQuery.group_id) {
            this.selectedGroup = this.groups[i]
          }
        }
      }

      if(this.groups.length === 1) {
        this.selectedGroup = this.groups[0]
      }

      this.initWizard()

    },
    async initWizard() {
      if((this.subsidiaries.length === 1 && this.groups.length === 1) || (this.selectedSubsidiary !== null && this.selectedGroup !== null)) {
        await this.getForm()
        // remove step 1
        this.wizardDisplayStep1 = (this.preform.length > 0)
        this.validateSubsidiaryGroup()
      }

      this.wizardDisplay = true
    },
    onDayClick() {
      this.getAppointments()
    },
    async getAppointments() {
      this.selectedDate = null
      const appointmentFilter = this.groupFilterFromPreForm.join(',')
      const result = await this.axios.get('appointment-groups/' + this.selectedGroup.id + '/appointments?from='+this.selectedDay+'&to='+this.selectedDay+'&appointment_filter='+appointmentFilter)
      this.availableSlots = result.data.map(
              (obj) => {
                return {
                  "id" : obj.id,
                  "text" : this.$moment(obj.date).format("HH:mm"),
                  "date" : obj.date
                };
              }
          );

    },
    async getForm() {

      if(this.form.length > 0) return

      const result = await this.axios.get('appointment-groups/' + this.selectedGroup.id + '/form')

      this.form = result.data
      this.preform = []
      this.formToken = result.headers['x-form-token']
      this.formStates = {}
      for(let formelement of this.form) {
        this.formStates[formelement.key] = null
      }

      this.formRules = {}
      for(const formelement of this.form) {
        if(formelement.config.validation_rules || formelement.type === 'email') {
          let rule = formelement.config.validation_rules
          if(formelement.type === 'email') rule += "|email"
          if(formelement.type === 'input' || formelement.type === 'textarea') rule += "|min:3"
          this.formRules[formelement.key] = rule
        }
        if(formelement.config.has_appointment_filter && formelement.config.has_appointment_filter == 'true') {
          this.preform.push(formelement)
        }
      }

    },
    async getAvailableDates() {

      this.errors = {}
      this.availableSlots = []

      const minDate = this.$moment().add(this.selectedGroup.offset_days_start, 'days').format("YYYY-MM-DD")
      const maxDate = this.$moment(minDate).add((this.selectedGroup.offset_days_length - 1), 'days').format("YYYY-MM-DD")
      const appointmentFilter = this.groupFilterFromPreForm.join(',')

      this.calendarConfig.enable = []

      const result = await this.axios.get('booking/appointments/?group=' + this.selectedGroup.id + '&from='+minDate+'&to=' + maxDate + "&appointment_filter=" + appointmentFilter)
      if(Object.keys(result.data).length === 0) {
        this.$set(this.errors, 'NO_APPOINTMENTS_LEFT', true)
      }
      else {

        for (const date in result.data) {
          this.calendarConfig.enable.push( date )
        }

        if (this.calendarConfig.enable.length > 0) {
          this.calendarConfig.minDate = this.calendarConfig.enable[0]
        }

      }


    },
    async validateSubsidiaryGroup() {
      // Before Change Step 2
      if (this.selectedGroup && this.selectedSubsidiary && this.selectedGroup.id > 0 && this.selectedSubsidiary.id > 0) {
        // await this.getForm()
        if(!this.wizardDisplayStep1) {
          await this.getAvailableDates()
        }

        if(this.preform.length > 0) {
          for(const formelement of this.preform) {
            if(!this.validateFormelement(formelement)) return false
          }
        }

        this.availableSlots = []
        this.selectedDay = null
        await this.overwriteGroupSettings()

        return true
      }

      return false
    },
    async overwriteGroupSettings() {

      const groupSettings = await this.axios.get('/settings?path=appointmentgroup.' + this.selectedGroup.id + '.frontend.*')
      this.groupSettings = groupSettings.data

      for(let key in this.groupSettings) {
        const defaultKey = key.replace('.' + this.selectedGroup.id + '.', '.default.')
        if(this.settings[defaultKey]) {
          this.settings[defaultKey] = this.groupSettings[key]
        }
      }

    },
    validateDate() {
      return (this.selectedDate !== null)
    },
    validateFormelement(formelement) {

      let validInput = true
      this.groupFilterFromPreForm = []

      if(formelement && formelement.config.validation_rules && formelement.config.validation_rules.indexOf('required') >= 0) {

        if(!this.userInput[formelement.key]) {
          validInput = false
        }
        else if(formelement.type === 'email') {
          const re = /\S+@\S+\.\S+/;
          validInput = re.test(this.userInput[formelement.key]);
        }
        else if (formelement.type === 'input' || formelement.type === 'textarea') {
          validInput = (this.userInput[formelement.key].length >= 3)
        }
        else if (formelement.type === 'captcha') {
          validInput = (this.userInput[formelement.key].length == 5)
        }
        else if (formelement.type === 'checkbox') {
          validInput = this.userInput[formelement.key]
        }

        this.formStates[formelement.key] = validInput

      }

      if(formelement && formelement.type === 'select') {

        let formelementLabel = null
        for(const element of this.form) {
          if(element.key === formelement.key && element.config.options.length > 0) {
            for(const option of element.config.options) {
                if(option.content === this.userInput[formelement.key]) {
                  formelementLabel = option.label
                  if(formelement.config.has_appointment_filter && formelement.config.has_appointment_filter == 'true') {
                    if(option.appointment_filter && option.appointment_filter.length > 0) this.groupFilterFromPreForm = option.appointment_filter
                  }
                  break
                }
            }
          }
        }

        if(formelementLabel) this.userInput[formelement.key+':label'] = formelementLabel
      }

      return validInput
      /*

      let tempRules = {}
      tempRules[key] = this.formRules[key]

        let validateResult = true
      try{
        await validate(this.userInput, tempRules)
      }  catch(e) {
          validateResult = false
      }
*/

    },
    async validateForm () {

      let formIsValid = true
      this.errors = {}

      for(const formelement of this.form) {
        if (!this.validateFormelement(formelement)) formIsValid = false
      }
      this.formValidateCount++

      if(formIsValid) {

       const postData = {
         appointment_id: this.selectedDate.id,
         form_values: this.userInput
       }

       try {

          await this.axios.post('appointments/' + this.selectedDate.id + '/tickets', postData, {
            headers: {
              'X-Form-Token': this.formToken
            }
          })

         this.userInput = {}
         this.form = {}
         this.formToken = null
         this.selectedDate = null
         this.selectedDay = null
         this.selectedGroup = null

        } catch(e) {

          if(e.response.status !== 200) {
            formIsValid = false

            if(e.response.data.type === 'captcha') {
              this.formStates[e.response.data.key] = false
              this.userInput[e.response.data.key] = ''
              this.formToken = e.response.headers['x-form-token']
              this.form.pop()
              this.form.push(e.response.data)

            }
            else {

              for (let field in this.formStates) {
                this.formStates[field] = true
              }

              const errors = e.response.data
              for (let error of errors) {
                this.formStates[error.field] = false
              }

            }

            if(e.response.data === 'ERR_NO_TICKETS_LEFT') {
              // kein freier slot mehr frei
              this.errors.ERR_NO_TICKETS_LEFT = true
            }


            this.formValidateCount++

          }

        }

      }

      return formIsValid
      /*
      return new Promise(resolve => {

        validateAll(this.userInput, this.formRules)
                .then(() => {
                  return resolve(true)
                })
                .catch((errors) => {

                  for(const formelement of this.form) {
                    this.formStates[formelement.key] = null
                  }

                  for(const error of errors) {
                    this.formStates[error.field] = false
                  }
                  this.formValidateCount++

                  return resolve(false);

                })
      }) */
    },
    resetWizard () {
      this.$refs.wizard.reset()
      this.getGroups()
    },
    async onGroupChange () {
      this.form = []
      this.preform = []
      await this.getForm()
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

  }
}
</script>
<style>
  @import './../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import './../../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  @import './../custom.css';
  @import './../../node_modules/vue-form-wizard/dist/vue-form-wizard.min.css';
  @import './../../node_modules/flatpickr/dist/flatpickr.css';

  .flatpickr-input {
    display:none;
  }
  .flatpickr-wrapper {
    width:100%;
  }
  .form-html-content p {
    margin-bottom: 0;
  }
</style>
